import { schemeConfigurationValuesTypes } from "../../types";

export const schemeDefaultValues: schemeConfigurationValuesTypes = {

    schemeDisclaimers: {
        "name": "schemeDisclaimers",
        "type": "list",
        "value": [""],
        "docUrl": "",
        "description": ".",
        "possibleVals": []
    },

    slabVisibilityInSchemes: {
        "name": "slabVisibilityInSchemes",
        "type": "boolean",
        "value": false,
        "docUrl": "",
        "description": "",
        "possibleVals": [
            true,
            false
        ]
    },
    viewSchemeCount: {
        "name": "viewSchemeCount",
        "type": "boolean",
        "value": false,
        "docUrl": "",
        "description": "",
        "possibleVals": [
            true,
            false
        ]
    },
    schemeWithSequence: {
        "name": "schemeWithSequence",
        "type": "boolean",
        "value": false,
        "docUrl": "",
        "description": "",
        "possibleVals": [
            true,
            false
        ]
    },
    showViewAllForSchemes: {
        "name": "showViewAllForSchemes",
        "type": "boolean",
        "value": false,
        "docUrl": "",
        "description": "",
        "possibleVals": [
            true,
            false
        ]
    },
    uptoSchemeLabel: {
        "name": "uptoSchemeLabel",
        "type": "boolean",
        "value": false,
        "docUrl": "",
        "description": "To make scheme upto lable visible.",
        "possibleVals": [
            true,
            false
        ]
    },

    createCustomSchemeText: {
        "name": "createCustomSchemeText",
        "type": "boolean",
        "value": false,
        "docUrl": "",
        "description": "To make scheme upto lable visible.",
        "possibleVals": [
            true,
            false
        ]
    },

    uptoSchemeAmountThreshhold: {
        "name": "uptoSchemeAmountThreshhold",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "threshold upto which amount banner won't be visible.",
        "possibleVals": []
    },
    uptoSchemeItemThreshhold: {
        "name": "uptoSchemeItemThreshhold",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "threshold upto which item banner won't be visible.",
        "possibleVals": []
    },
    uptoSchemePercentThreshhold: {
        "name": "uptoSchemePercentThreshhold",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "threshold upto which percent banner won't be visible.",
        "possibleVals": []
    }


}